import { Component, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { TranslatePipe } from '@ngx-translate/core'; // tslint:disable-line

import { SelectDialogExportService } from "./select-dialog-export-service";
import { INode } from "../Configuration/INode";
import { OxeModelService } from "../oxe-model-service/oxe-model.service";




@Component({
    selector: 'modal-confirm-select-export',
    templateUrl: './select-dialog-export.component.html',
    styleUrls: ['../../assets/theme/css/ConfirmDialog.css'],
    animations: [
        trigger('opening', [
            transition(':enter', [
                style({ 'opacity': 0 }),
                animate('300ms', style({ opacity: 1 }))
            ])
        ])
    ]

})
export class SelectDialogExportComponent implements OnInit {

    public isActive: boolean = false;

    public dialogType: string;
    public titleLabel: string;
    public messageLabel: string;
    public details: string;
    public okLabel: string;
    public cancelLabel: string;
    private node: INode;
    private _deferred;
    selectedAll: any;
    subClassNames: Array<Object>;

    private isOkClicked;
    private _defaults = {
        dialogType: 'confirm',
        titleLabel: '',
        messageLabel: 'are-you-sure',
        details: undefined,
        cancelLabel: 'cancel',
        okLabel: 'ok'
    };

    constructor(private confirmService: SelectDialogExportService, private oxeModelService: OxeModelService) {
        confirmService.alert = this.alert.bind(this);
        confirmService.confirm = this.confirm.bind(this);

    }

    // ---
    // PUBLIC METHODS.
    // ---

    public alert(message = this._defaults.messageLabel, title = this._defaults.titleLabel) {
        return this._activate('alert', message, title);
    }

    public confirm(message = this._defaults.messageLabel, subClasseNames, title = this._defaults.titleLabel, details = this._defaults.details) {
        this.subClassNames = subClasseNames;
        this.confirmService.subclassList = this.subClassNames;
        return this._activate('confirm', message, title, details);
    }

    public isConfirm() {
        return this.dialogType === 'confirm';
    }

    public onConfirm() {
        this.isOkClicked = true;

        this._hideDialog();
        this._deferred.resolve();
    }

    public onSelectAll() {
        for (let i = 0; i < this.confirmService.subclassList.length; i++) {
            this.confirmService.subclassList[i]['checked'] = true;

        }
    }

    public onDeSelectAll() {
        for (let i = 0; i < this.confirmService.subclassList.length; i++) {
            this.confirmService.subclassList[i]['checked'] = false;
        }
    }

    public onCancel() {

        this._hideDialog();
        this._deferred.reject();
    }

    // ---
    // PRIVATE METHODS.
    // ---

    private _activate(type = this._defaults.dialogType, message = this._defaults.messageLabel, title = this._defaults.titleLabel, details = this._defaults.details) {
        this._setDialog(type, message, title, details);

        this._showDialog();

        this._deferred = new Deferred<void>();
        return this._deferred.promise;
    }

    private _setDialog(type = this._defaults.dialogType, message = this._defaults.messageLabel, title = this._defaults.titleLabel, details = this._defaults.details) {
        this.dialogType = type;
        this.titleLabel = title;
        this.messageLabel = message;
        this.details = details;
        this.okLabel = this._defaults.okLabel;
        this.cancelLabel = this._defaults.cancelLabel;
    }

    private _showDialog() {
        this.isActive = true;
    }

    private _hideDialog() {
        this.isActive = false;
    }

    ngOnInit(): any {
    }



    /* get filterableAttributes(): Array<Object> {
         let newNode = new Node(NodeType.Object, this.node, this.node['structure'], fromObject, index, isLocal);
        //ignore new server node with undefined name (eg undefined id)
        if (!newNode.name && !isLocal) {
            return undefined;
        }
        let existingNode: Node = parentNode.subNodes.find((x: INode) => { return x.name === newNode.name && x.isLocal === false; }) as Node;
        //  this.oxeModelService.retrieveSubNodes(this.node);
      let subClassNames: Array<Object> = [];
         if (!this.node.subNodes) {
             let nodes: Array<INode> = [];
             let nodeStructure = this.node['structure'];
             // must have a structure
             if (nodeStructure && nodeStructure.hasOwnProperty('subClasses')) {
                 for (let key in nodeStructure['subClasses']) {
                     if(key != undefined)
                         subClassNames.push({ 'name' :key, 'checked': false });
                 }
             }

      }
         let mainClassName = {'name' : this.node.name, 'checked': true};
         subClassNames.unshift(mainClassName);
         console.log(subClassNames);
         return subClassNames;


    } */
}
/**
 * A lightweight Deferred implementation, using native Promises.
 *
 * ### Example
 *
 * ```typescript
 * var deferred = new Deferred<string>();
 *
 * // set up handlers
 * deferred.promise.then(function (value) {}, function (error) {});
 *
 * // resolve
 * deferred.resolve('a value');
 *
 * // reject
 * deferred.reject(new Error('oh no!'));
 *
 * ```
 *
 */
class Deferred<T> {

    // The Deferred’s Promise object.
    promise: Promise<T>;

    // Resolve the Deferred object and call any 'done' callbacks with the given args.
    resolve: (value?: T | PromiseLike<T>) => void;

    // Reject a Deferred object and call any 'fail' callbacks with the given args.
    reject:  (reason?: any) => void;

    constructor() {
        this.promise = new Promise<T>((resolve, reject) => {
            this.resolve = resolve;
            this.reject  = reject;
        });
    }
}
